import { en, type MessageKey } from './en';

export type { MessageKey };

/**
 * Translate a message key, substituting `{name}` placeholders.
 * Only English exists today; a locale switch will select the catalogue here.
 */
export function t(key: MessageKey, params: Record<string, string | number> = {}): string {
  return en[key].replace(/\{(\w+)\}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  );
}
